// Nav scroll state + mobile drawer + product page image swap + dispatch form.

const nav = document.getElementById('nav');
const hamburger = document.getElementById('navHamburger');
const drawer = document.getElementById('navDrawer');
const drawerClose = document.getElementById('navDrawerClose');
const drawerScrim = document.getElementById('navDrawerScrim');

// Nav scrolled state is owned solely by aa26.js (it toggles `.scrolled` with a
// hero-aware threshold on home and immediately on sub-pages, and works without GSAP).
// The old flat y>40 `is-scrolled` toggle here was a second, desynced source of truth
// (border fired at 40px while the colour-flip waited for the hero bottom) — removed.

// Mobile drawer. State is mirrored into ARIA: the drawer's aria-hidden and
// the hamburger's aria-expanded must always match the visual state.
function openDrawer() {
  drawer?.classList.add('is-open');
  drawer?.setAttribute('aria-hidden', 'false');
  hamburger?.setAttribute('aria-expanded', 'true');
  drawerScrim?.classList.add('is-active');
  window.AAScrollLock?.lock();
}
function closeDrawer() {
  if (!drawer?.classList.contains('is-open')) return;
  drawer?.classList.remove('is-open');
  drawer?.setAttribute('aria-hidden', 'true');
  hamburger?.setAttribute('aria-expanded', 'false');
  drawerScrim?.classList.remove('is-active');
  window.AAScrollLock?.unlock();
}
hamburger?.addEventListener('click', openDrawer);
drawerClose?.addEventListener('click', closeDrawer);
drawerScrim?.addEventListener('click', closeDrawer);
drawer?.querySelectorAll('a').forEach(a => a.addEventListener('click', closeDrawer));
window.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

// Product page: detail thumb → primary image swap
document.addEventListener('click', e => {
  const thumb = e.target.closest('.detail-thumb');
  if (!thumb) return;
  const primary = document.getElementById('productPrimary');
  const src = thumb.dataset.src;
  if (!primary || !src) return;
  if (thumb.classList.contains('is-active')) return;
  document.querySelectorAll('.detail-thumb').forEach(t => t.classList.remove('is-active'));
  thumb.classList.add('is-active');
  const ss = thumb.dataset.srcset || '';
  // srcset takes precedence over src in the browser's selection algorithm, so swap BOTH.
  const apply = () => { primary.src = src; if (ss) primary.srcset = ss; else primary.removeAttribute('srcset'); };
  const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { apply(); return; }
  // Fade out IMMEDIATELY (responsive to the click), preload+decode in parallel, then swap a
  // ready frame and fade back in — never a flash-to-empty or a hard cut. `pending` guards
  // against rapid thumb clicks so a stale decode can't overwrite a newer pick.
  primary.dataset.pending = src;
  primary.style.opacity = '0';
  const pre = new Image();
  if (ss) pre.srcset = ss;
  pre.src = src;
  const reveal = () => {
    if (primary.dataset.pending !== src) return;
    apply();
    requestAnimationFrame(() => { primary.style.opacity = '1'; });
  };
  if (pre.decode) pre.decode().then(reveal).catch(reveal);
  else if (pre.complete) reveal();
  else { pre.onload = reveal; pre.onerror = reveal; }
});

// Dispatch form is handled natively by Shopify's {% form 'customer' %} — no JS interception.
